<template>
  <div :class="[{'wrapper': !onEditor}, {'browser-wrapper': !isIos}]" :style="iosOrAndroidStyle"
       v-if="loadingPageOver">
    <div v-if="!loadingShow || loadingOver">
      <w-navbar v-if="iosOrAndroidShow && !onEditor" :icon="'iconchevron-left'"
                :nav_title="sectionTitle" @mobileLeftBtn="backToEditor" :right_btn_html="rightBtnHtml"
                @mobileRightBtn="saveContent">
      </w-navbar>
      <module-content :experience-show="!!experienceData.length" :experience-tool-tip="experienceTooltipShow"
                      @changeExperienceState="changeExperienceState"
                      @saveContent="saveContent" v-if="onEditor"/>
      <w-cv-form v-if="!onEditor" :formList="formList" :req="formData" :section-type="sectionType"/>
      <div v-if="!onEditor && moduleType !== 'honor'" class="module-edit" @click="toEditContent">
        <div class="title">
          <span>{{ contentDesc.title }}</span>
        </div>
        <div class="flex-between">
          <div class="content" :class="{'no-content': !formData.description}"
               v-html="formData.description || contentDesc.desc">
          </div>
          <span class="iconfont iconchevron-right"/>
        </div>
      </div>
      <div class="more-operate flex-start footer" v-if="!onEditor">
        <div class="flex-center delete" @click="deleteInfoConfirm" v-if="deleteState">
          <span class="iconfont iconshanchu"></span>
          <span>删除</span>
        </div>
        <div class="flex-center experience" v-if="experienceData.length">
          <w-tooltip v-if="experienceTooltipShow" class="w-tooltip" @handleClose="closeToolTip"></w-tooltip>
          <span class="iconfont iconbox"></span>
          <span @click="changeExperienceState">经历库</span>
        </div>
        <div class="flex-center tips" @click="changeTipsStatus">
          <span class="iconfont iconwenhao"></span>
          <span>小贴士</span>
        </div>
      </div>
    </div>
    <cv-tips :state="cvTipShow" :tip-data="tipData" @handleClose="changeTipsStatus"/>
    <experience-dialog :state="experienceState" :radio="true" :experience-data="experienceData" :title="sectionTitle"
                       ref="experienceDialog" @changeCustomCheck="changeCustomCheck"
                       @selectExperience="selectExperience" @handleClose="changeExperienceState"
                       @deleteExperience="deleteExperience"></experience-dialog>
    <w-loading v-if="loadingShow"/>
  </div>
</template>

<script>
	import WNavbar from '@/components/global/w-navbar'
	import WLoading from '@/components/global/w-loading'
	import WCvForm from '@/components/cv/w-cv-form'
	import moduleContent from '../text-editor/module-content'
	import { mapActions, mapMutations, mapState, mapGetters } from 'vuex'
	import { componentsMixin } from '../../../assets/js/mixin/components'
	import { moduleMixin } from '../../../assets/js/mixin/cv'
	import { envMixin } from '../../../assets/js/mixin/global'
	import { deleteRedundancy, setupWebViewJavascriptBridge } from '@/assets/js/utils'
	import { eventMixin } from '../../../assets/js/mixin/global'
	import experienceDialog from '@/views/cv-experience/experience-dialog'
	import { userMixin } from '../../../assets/js/mixin/user'

	let formJson = require('@/assets/json/cv')
	let moment = require('moment')

	/*
  这里定义路由是params中的custom_id代表整个大模块的id，info_id代表里面某一段经历的id
   */

	export default {
		mixins: [ componentsMixin, moduleMixin, envMixin, eventMixin, userMixin ],
		data () {
			return {
				req: {},
				loadingShow: false,
				experienceData: [],
				experienceState: false, // 经历库弹窗状态
				formData: {}
			}
		},
		beforeRouteEnter (to, from, next) {
			next(vm => {
				vm.fromName = from.name
			})
		},
		beforeRouteLeave (to, from, next) {
			if (!to.path.includes('content_edit')) {
			}
			next()
		},
		async mounted () {
			setTimeout(() => {
				this._initInfo()
			}, 0)
		},
		components: {
			WNavbar,
			WCvForm,
			WLoading,
			moduleContent,
			experienceDialog
		},
		watch: {},
		computed: {
			...mapState('cv', [ 'cv', 'customSectionInfo' ]),
			...mapState('cvExperience', [ 'personal_summary', 'project_experience', 'reasearch_experience', 'honor', 'skill_list', 'custom', 'custom_ids' ]),
			...mapGetters('cvExperience', [ 'currentCustomId' ]),
			// 模块编辑的默认显示内容
			contentDesc () {
				let { type } = this.$route.params
				let { cv_type } = this.cv.basic_info
				switch (type) {
					case 'project_experience':
						if (cv_type.includes('programmer')) {
							return { title: '项目描述', desc: '简要说明参与开发的项目，附加超链接，展现自己的专业能力' }
						} else {
							return { title: '项目描述', desc: '介绍在什么样项目中自己负责的内容，列出通过什么动作或技能达到了什么成果（最好是可量化的）' }
						}
					case 'reasearch_experience':
						return { title: '研究描述', desc: '介绍研究项目如毕业论文，小组项目等，描述负责的具体内容，以及最终的项目成果，受到导师好评、获奖情况等' }
					case 'custom':
						return { title: '经历描述', desc: '介绍在什么经历中，通过某些活动或技能，达到了什么样的成果' }
				}
				return {}
			},
			// 传给form的字段，用来添加样式class
			sectionType () {
				let { type } = this.$route.params
				return type === 'project_experience' ? 'project' : 'other'
			},
			// 个人总结和技能只显示text-editor
			onEditor () {
				let { type } = this.$route.params
				return !(type !== 'personal_summary' && type !== 'skill_list')
			},
			// 获取当前是哪个模块显示哪个模块的form
			formList () {
				let { type } = this.$route.params
				if (type === 'custom') {
					return formJson[`_form`]
				} else {
					return formJson[`${ type.replace(/"/g, '') }_form`]
				}
			},
			// 是否显示删除info按钮
			deleteState () {
				let { info_id } = this.$route.params
				return info_id !== 'add'
			}
		},
		methods: {
			...mapActions('cv', [ 'getSectionInfo', 'createCustom', 'createCustomInfo', 'updateCustomInfo', 'getShowNpsState' ]),
			...mapActions('cvExperience', [ 'getCustomExperience' ]),
			...mapMutations('cv', [ 'changeCurrentInfo' ]),
			...mapMutations('cvExperience', [ 'changeExperienceField', 'changeCustomId' ]),
			backToEditor () {
				this.verifyData({ req: this.formData, count: this.count })
			},
			// type 为custom的经历库选中事件
			changeCustomCheck (info) {
				let listClone = JSON.parse(JSON.stringify(this.experienceData))
				listClone.forEach(item => item.checked = info.id === item.id)
				this.experienceData = listClone
			},
			// 跳转text-editor
			toEditContent () {
				let { type, custom_id, info_id, token } = this.$route.params
				this.$router.push(`/cvs/${ token }/${ custom_id }/${ type }/${ info_id }/content_edit`)
				this.changeCurrentInfo(this.formData)
			},
			// 删除经历库中的经历
			deleteExperience (item) {
				let { type, custom_id } = this.$route.params
				let infos = []
				if (type === 'custom') {
					const custom = this.$store.state.cvExperience.custom.find(val => val.id === item.custom_section_id)
					if (custom) infos = custom.infos
				} else {
					infos = this.$store.state.cvExperience[type]
				}
				let res = {}
				this.$createDialog({
					title: '提示',
					type: 'confirm',
					content: `删除无法还原,确定删除?`,
					onConfirm: async () => {
						try {
							if (infos && infos.length === 1) {
								res = await this.$api.cv.deleteCustom(item.custom_section_id)
							} else {
								res = await this.$api.cv.deleteCustomInfo(item.custom_section_id, item.id)
							}
							if (res.code === 1000) {
								this.experienceData = this.experienceData.filter(val => val.id !== item.id)
								if (!this.experienceData.length) this.changeExperienceState()
							} else {
								this.$createDialog({
									type: 'alert',
									content: '该段经历在其他简历被使用，无法删除',
									confirmBtn: '我知道了',
								}).show()
							}
						} catch (e) {
							console.log(e)
						}
					}
				}).show()
			},
			// 删除经历的弹窗提示
			deleteInfoConfirm () {
				let { submodule_info } = this.cv
				let { custom_id, info_id, type } = this.$route.params
				let { basic_info: { token } } = this.cv
				let position = JSON.parse(JSON.stringify(submodule_info.sections_position))
        let content = null;
				position.forEach((val, index) => {
					delete val.title
					if (val.id === Number(custom_id)) {
            if(val.info_ids.length === 1){
              position.splice(index, 1);
              content = '删除内容将无法还原\n确定要删除当前模块吗？';
            }else {
						  val.info_ids = val.info_ids.filter(item => item !== Number(info_id))
              content = '删除无法还原,确定删除?';
            }
					}
				})
				let payload = {
					operation_type: 'update_submodule_info',
					submodule_info: {
						sections_position: position
					}
				}
				this.$createDialog({
					title: '提示',
					type: 'confirm',
					content,
					onConfirm: async () => {
						try {
							await this.updateCvDetail({ token, payload })
							this.$fn.redirect(
								`${window.location.origin}/cvs/${ token }/editor`,
								() => {
									this.$router.replace(`/cvs/${ token }/editor`)
								}
							)
						} catch (e) {
							console.log(e)
						}
					}
				}).show()
			},
			// 保存按钮事件
			async saveContent (textEditor) {
				let editorToken = this.$db.ls.get(`${ this.cvAccountToken }-editor`)
				if (!this.infoNotEmpty(this.formData) && this.moduleType !== 'personal_summary' && this.moduleType !== 'skill_list' && !textEditor) {
					this.showToast('完善经历信息，更容易获得青睐哦', 2000)
					return
				} else if (!editorToken && !this.formData.description) {
					this.$createDialog({
						type: 'confirm',
						content: `经历描述是模块的重要内容<br>建议参考填写案例去完善`,
						confirmBtn: { text: '去完善', },
						cancelBtn: { text: '忽略', },
						onConfirm: () => {
							this.toEditContent()
						},
						onCancel: () => {
							this.$db.ls.set(`${ this.cvAccountToken }-editor`, true)
							this._saveContent()
						}
					}).show()
				} else {
					this._saveContent()
				}
			},
			// 保存经历逻辑
			async _saveContent (textEditor) {
				try {
					// this.formData.description = this.formData.description ?
					// 	this.formData.description.replace(/(?<= )class=".*?"/gi, '').replace(/<div/gi, '<p').replace(/\/div>/gi, '\/p>') :
					// 	null
					let { custom_section_id } = this.formData
					if (this.custom_ids[`${ custom_section_id }_id`]) this.changeCustomId(custom_section_id)
					let { type, custom_id, info_id, token } = this.$route.params
					if (this.formData.id && custom_section_id === this.currentCustomId) {
						let info = type === 'custom' ?
							this.experienceData.filter(item => item.id === this.formData.id)[0] :
							this[type].filter(item => item.id === this.formData.id)[0]
						if (!this.contrastInitData(this.formData, info)) {
							if (this.formData.id === Number(info_id)) {
								this.$fn.redirect(
									`${window.location.origin}/cvs/${ token }/editor`,
									() => {
										this.$router.replace(`/cvs/${ token }/editor`)
									}
								)
							} else {
								// 同步给cv detail
								this._updateCvDetail(this.currentCustomId, this.formData.id)
							}
						} else if (this.contrastInitData(info, this.formData)) {
							if (await this.verifyExperience()) {
								this.$createDialog({
									title: '修改同步提示',
									type: 'confirm',
									content: `此段经历在其他简历中被引用，<br>是否同步修改到其他简历？`,
									confirmBtn: '同步',
									cancelBtn: '不同步',
									onConfirm: () => {
										this.experienceChange('update')
									},
									onCancel: () => {
										this.experienceChange('create')
									}
								}).show()
							} else {
								this.experienceChange('update')
							}
						}
					} else {
						this.experienceChange('create')
					}
				} catch (e) {
					console.log(e)
				}
        this.getShowNpsState()
			},
			// 保存或者创建经历
			async experienceChange (operation) {
				let { type } = this.$route.params
				let data = JSON.parse(JSON.stringify(this.formData))
				let payload = {
					...deleteRedundancy(data),
					lang: this.cv.basic_info.lang
				}
				if (payload.end_at === '至今' || payload.end_at === 'Present') {
					payload.present = payload.end_at
					payload.end_at = null
				} else if (payload.end_at) {
					payload.present = null
				}
				payload.start_at = payload.start_at ? moment.utc(payload.start_at) : null
				payload.end_at = payload.end_at ? moment.utc(payload.end_at) : null
				if (operation === 'update') {
					this.updateCustomInfo({ customId: this.currentCustomId, infoId: this.formData.id, payload })
					this._updateCvDetail(this.currentCustomId, this.formData.id)
				} else if (operation === 'create') {
					if (this.currentCustomId) {
						let data = await this.createCustomInfo({ id: this.currentCustomId, payload })
						if (data === 80143) {
							this.showAlert('每个模块最多添加30段经历<br>请删除多余经历后重试', '我知道了')
						} else {
							this._updateCvDetail(this.currentCustomId, data.id)
						}
					} else {
						let data = await this.createCustom({ ...payload, category: type === 'custom' ? null : type })
						this._updateCvDetail(data.id, data.infos[0].id)
					}
				}
			},
			// 更新cv里面的信息
			async _updateCvDetail (customId, id) {
				let { token, type, info_id, custom_id } = this.$route.params
				let { kind } = this.cv.basic_info
				let position = JSON.parse(JSON.stringify(this.cv.submodule_info.sections_position))
				let payload = {
					operation_type: kind === 'template' || kind === 'sample' ? '' : 'update_submodule_info',
				}
				// 从排序中找到当前编辑的模块的位置
				const moduleIndex = position.findIndex(item => item.type === 'custom' ? item.id === this.currentCustomId : item.type === type)
				// 找到编辑时的 id 在 ids 里面的位置
				let infoIndex = -1
				if (moduleIndex > -1) {
					let ids = position[moduleIndex].info_ids
					infoIndex = ids.findIndex(item => item === Number(info_id))
				}
				// 看是在排序中增加模块还是
				if (moduleIndex === -1) {
					position = [
						...position,
						{ type, id: customId, info_ids: [ id ] }
					]
				} else {
					position.forEach(item => {
						if (item.type === type) {
							item.id = customId
							infoIndex > -1 && this.currentCustomId === customId ? item.info_ids[infoIndex] = id : this.currentCustomId === customId ? item.info_ids = [ ...item.info_ids, id ] : item.info_ids = [ id ]
						}
					})
				}
				position.forEach(item => delete item.title)
				if (kind === 'template' || kind === 'sample') {
					payload.basic_info = {
						...this.cv.basic_info,
						source_cv_token: this.cv.basic_info.token || null,
						sample_cv_source_token: this.cv.basic_info.token || null, // 记录简历是否是从“大牛简历模板”还是从“八大模板”创建
						kind: null,
						token: null
					}
					payload.submodule_info = {
						...this.cv.submodule_info,
						custom_sections_ids: [ ...new Set([
							...this.cv.submodule_info.custom_sections_ids.filter(item => item !== Number(custom_id)),
							customId
						]) ],
						sections_position: position
					}
					payload.format_info = this.cv.format_info
					let res = await this.createCvDetail(payload)
					if (res.code === 3001) {
						this.showToast(res.message)
						return
					}
					this.$fn.redirect(
            `${window.location.origin}/cvs/${ this.cv.basic_info.token }/editor`,
            () => {
              this.$router.replace(`/cvs/${ this.cv.basic_info.token }/editor`)
            }
          )
				} else {
					payload.submodule_info = {
						sections_position: position,
						custom_sections_ids: [ ...new Set([
							...this.cv.submodule_info.custom_sections_ids.filter(item => item !== Number(custom_id)),
							customId
						]) ]
					}
					await this.updateCvDetail({ token, payload })
					this.$fn.redirect(
            `${window.location.origin}/cvs/${ this.cv.basic_info.token }/editor`,
            () => {
              this.$router.replace(`/cvs/${ this.cv.basic_info.token }/editor`)
            }
          )
				}
			},
			// 初始化页面的数据
			async _initInfo () {
				try {
					let { custom_id, info_id, type } = this.$route.params
					let { lang, kind } = this.cv.basic_info
					let { submodule_info: { sections_position } } = this.cv
					this.getExperienceInfo(info_id, type, lang)
					this.changeExperienceField(type)
					await this.getCustomExperience({ template: [], payload: { lang, kind } })
					// 获取经历库数据
					let customInfos = []
					if (type === 'custom') {
						const index = this.custom.findIndex(item => item.id === Number(custom_id))
						if (index > -1) this.changeCustomId(this.custom[index].id)
					}
					// 把当前简历里面有的id拿出来
					if (custom_id !== 'create_custom') {
						let custom = sections_position.filter(item => item.id === Number(custom_id))[0]
						customInfos = custom ? custom.info_ids : []
					}
					// 过滤掉经历库中当前简历有的id
					if (this[type] && this[type].length) {
						let experienceData = []
						if (custom_id === 'create_custom') {
							if (type === 'custom') {
								// 拿到当前用户的所有自定义经历
								this.custom.forEach(item => experienceData = experienceData.concat(item.infos))
								this.experienceData = experienceData
								// 获取到当前简历里面的所有自定义经历
								sections_position.forEach(item => {
									if (item.type === 'custom') customInfos = [ ...customInfos, ...item.info_ids ]
								})
								console.log(customInfos, 'custom-=-=-=-')
								// 把简历里面有的自定义模块清除掉
								this.experienceData = this.experienceData.filter(item => !customInfos.includes(item.id))
							} else {
								this.experienceData = this[type]
							}
						} else {
							let data = []
							if (type === 'custom') {
								let customModule = this.custom.filter(item => item.id === Number(custom_id))
								data = customModule[0] ? customModule[0].infos : []
							} else {
								data = this[type]
							}
							this.experienceData = data.filter(item => {
								if (!customInfos.includes(item.id) || item.id === Number(info_id)) {
									item.checked = item.id === Number(info_id)
									return item
								}
							})
						}
					}
					this.loadingShow = false
					this.loadingOver = true
				} catch (e) {
					// alert(e)
				}
			},
			// 校验当前经历是否被引用
			async verifyExperience () {
				let { id } = this.formData
				let res = await this.$api.cv.customVerify(this.currentCustomId, id)
				if (res.code === 1000) {
					return res.data.imported
				} else {
					return false
				}
			}
		}
	}
</script>
<style scoped lang="scss">
  @import '@/assets/scss/cv/module';
</style>
